import axios from "axios";
import { BACKEND_BASE_URL } from "../index";

const getApiUrl = (endpoint) => `${BACKEND_BASE_URL}${endpoint}`;

const GetAllVisitors = async () => {
  let config = {
    method: "get",
    url: getApiUrl("/Visitor/GetAllVisitors"),
  };
  return axios.request(config).then((response) => response);
};

const AddVisitor = async (visitorData) => {
  let config = {
    method: "post",
    url: getApiUrl(
      `/Visitor/AddVisitor?VV_Contact_person_id=${encodeURIComponent(visitorData.VV_Contact_person_id)}&VV_Name=${encodeURIComponent(visitorData.VV_Name)}&VV_NIC_Passport_NO=${encodeURIComponent(visitorData.VV_NIC_Passport_NO)}&VV_Visiting_places=${encodeURIComponent(visitorData.VV_Visiting_places)}&VV_Visitor_Type=${encodeURIComponent(visitorData.VV_Visitor_Type)}&VV_Phone=${encodeURIComponent(visitorData.VV_Phone)}&VV_Email=${encodeURIComponent(visitorData.VV_Email)}&VV_Company=${encodeURIComponent(visitorData.VV_Company)}`,
    ),
    data: "",
  };
  return axios.request(config).then((response) => response);
};

const GetVisitorById = async (id) => {
  let config = {
    method: "get",
    url: getApiUrl(
      `/Visitor/GetVisitorById?VV_Visitor_id=${encodeURIComponent(id)}`,
    ),
  };
  return axios.request(config).then((response) => response);
};

const ActivateVisitor = async (id, status) => {
  let config = {
    method: "post",
    url: getApiUrl(
      `/Visitor/ActivateVisitor?VV_Status=${encodeURIComponent(status)}&VV_Visitor_id=${encodeURIComponent(id)}`,
    ),
    data: "",
  };
  return axios.request(config).then((response) => response);
};

const GetVisitorsByContactPerson = async (cpId) => {
  let config = {
    method: "get",
    url: getApiUrl(
      `/Visitor/GetVisitorsByContactPerson?VV_Contact_person_id=${encodeURIComponent(cpId)}`,
    ),
  };
  return axios.request(config).then((response) => response);
};

const GetVisitorJoint = async (requestId) => {
  let config = {
    method: "get",
    url: getApiUrl(
      `/Visitor/VisitorJoint?RequestId=${encodeURIComponent(requestId)}`,
    ),
  };
  console.log("[VisitorService] GetVisitorJoint - URL:", config.url);
  try {
    const response = await axios.request(config);
    console.log("[VisitorService] GetVisitorJoint response:", response.data);
    return response;
  } catch (err) {
    console.error("[VisitorService] GetVisitorJoint error:", err.message);
    throw err;
  }
};

const UpdateVisitor = async (visitorData) => {
  let config = {
    method: "post",
    url: getApiUrl(
      `/Visitor/UpdateVisitor?VV_Visitor_id=${encodeURIComponent(visitorData.VV_Visitor_id)}&VV_Name=${encodeURIComponent(visitorData.VV_Name)}&VV_NIC_Passport_NO=${encodeURIComponent(visitorData.VV_NIC_Passport_NO)}&VV_Visiting_places=${encodeURIComponent(visitorData.VV_Visiting_places || "")}&VV_Visitor_Type=${encodeURIComponent(visitorData.VV_Visitor_Type || "")}&VV_Phone=${encodeURIComponent(visitorData.VV_Phone)}&VV_Email=${encodeURIComponent(visitorData.VV_Email)}&VV_Company=${encodeURIComponent(visitorData.VV_Company)}`,
    ),
    data: "",
  };
  return axios.request(config).then((response) => response);
};

export default {
  GetAllVisitors,
  AddVisitor,
  GetVisitorById,
  ActivateVisitor,
  GetVisitorsByContactPerson,
  GetVisitorJoint,
  UpdateVisitor,
};
